module.exports = __webpack_public_path__ + "img/Plus.9b2e9f48.svg";